import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import infoIconOutline from "../assets/icons/icon attention.svg";
import { AlertOptions } from "../context/AlertContextProvider";

type ModalProps = AlertOptions & { isOpen: boolean; onClose: () => void };

const AlertModal = ({
    isOpen,
    title,
    description,
    cancelText,
    onCancel,
    onClose,
}: ModalProps) => {
    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50">
            <DialogBackdrop className="fixed inset-0 bg-black/70" />
            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <DialogPanel className="relative flex flex-col w-full max-w-[800px] h-full max-h-[400px] bg-white p-6 rounded-[4px]">
                    <button
                        className="absolute top-0 right-0 m-3 size-9 rounded-full hover:bg-gray-100"
                        onClick={onClose}
                    >
                        <XMarkIcon className="size-full p-1.5" />
                    </button>
                    <div className="mt-10 flex flex-col items-center gap-2">
                        <img
                            src={infoIconOutline}
                            alt="info icon"
                            className="h-12"
                        />
                        <DialogTitle className="text-center font-semibold text-[22px] text-blue-dark">
                            {title}
                        </DialogTitle>
                        <p className="text-red-error whitespace-pre-line">{description}</p>
                    </div>
                    <button
                        onClick={onCancel}
                        className="btn-primary w-40 xl:w-[200px] mx-auto mt-auto"
                    >
                        {cancelText}
                    </button>
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export default AlertModal;
